/**
 * Single source of truth for translating a backend `featured_listings.tier`
 * (or `agency_featured_tier.tier`) into the UI label shown on a card.
 *
 * Keep this aligned with:
 *   - src/components/property/TierBadge.tsx
 *   - src/components/agencies/AgencyTierBadge.tsx
 */
export type BackendTier = 'super_hot' | 'hot' | 'standard' | null | undefined;
export type Surface = 'property' | 'plot' | 'commercial' | 'project' | 'agency';

export function tierLabel(tier: BackendTier, surface: Surface): string | null {
  if (!tier) return null;

  if (surface === 'agency') {
    if (tier === 'super_hot' || tier === 'hot') return 'Titanium';
    if (tier === 'standard') return 'Featured';
    return null;
  }

  if (tier === 'super_hot') return 'Super Hot';
  if (tier === 'hot') return 'Hot';
  if (tier === 'standard') return surface === 'project' ? 'Trending' : 'Featured';
  return null;
}
